import * as React from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import { Link } from 'react-router-dom'
import Menu from './Menu';
import AppVersion from './AppVersion/AppVersion';
import SearchBar from './SearchBar';
import DownloadApps from '../mobile/DownloadApps';


class NavBar extends React.Component {

    componentDidMount() {
        window.addEventListener('sidebar-close', this.closeSidebarMobile);
    }

    componentWillUnmount() {
        window.removeEventListener('sidebar-close', this.closeSidebarMobile);
    }

    state = {
        isSidebarVisible: false,
        isMobileSearchOpen: false,
    };

    navTogglerClickedSmall = () => {
        const { isSidebarVisible } = this.state;
        const nextVisible = !isSidebarVisible;
        if (nextVisible) {
            $("body").addClass("show-sidebar");
        } else {
            $("body").removeClass("show-sidebar");
        }
        this.setState({ isSidebarVisible: nextVisible, isMobileSearchOpen: false });
    };

    closeSidebarMobile = () => {
        $("body").removeClass("show-sidebar");
        this.setState({ isSidebarVisible: false });
    };

    toggleMobileSearch = () => {
        this.setState((prev) => ({ isMobileSearchOpen: !prev.isMobileSearchOpen }));
    };

    render() {
        const { impersonation, sidebarCollapsed, onToggleSidebar } = this.props;
        const isImpersonating = !!impersonation?.isActive;

        return (

            <header className="topbar background-rojo-megatone" >
                <nav className="navbar top-navbar navbar-expand-sm navbar-light" >

                    <div className="navbar-header background-gris-megatone">
                        <Link className="navbar-brand navbar-brand--market" to="/" aria-label="Marketplace Megatone.net">
                            <img
                                className="navbar-brand__mark"
                                src="/img/logo-mega-m.svg"
                                alt=""
                            />
                            <span className="navbar-brand__word">Marketplace Megatone.net</span>
                        </Link>
                    </div>

                    <div className="navbar-collapse justify-content-between row" >

                        <div className="col-1 d-flex align-items-center navbar-search-area" style={{ zIndex: 10, position: 'relative' }}>
                            <ul className="navbar-nav mr-auto d-none d-lg-block">
                                <li className="nav-item">
                                    <button
                                        type="button"
                                        onClick={onToggleSidebar}
                                        className="nav-link sidebar-toggle-btn waves-effect waves-dark"
                                        aria-label={sidebarCollapsed ? "Expandir menú lateral" : "Contraer menú lateral"}
                                        title={sidebarCollapsed ? "Expandir menú" : "Contraer menú"}
                                        aria-expanded={!sidebarCollapsed}
                                        aria-controls="sidebarnav"
                                    >
                                        <i className="sl-icon-menu ti-menu" aria-hidden="true" />
                                    </button>
                                </li>
                            </ul>

                            {/* Pasar idSeller y listenClear prop a SearchBar */}
                            <div className="d-flex flex-column justify-content-center pt-2">
                                <SearchBar idSeller={this.props.idSeller} listenClear={true} />
                                <div className="ms-3 text-white mt-1" style={{ fontSize: '11px', whiteSpace: 'nowrap' }}>
                                    <AppVersion />
                                </div>
                            </div>
                        </div>

                        <div className='col-11 navbar-user-area'>
                            <div className="w-100 row justify-content-end">
                                <div className="col-auto d-flex align-items-center navbar-mobile-toggle-slot">
                                    <button
                                        type="button"
                                        className="mobile-sidebar-toggle"
                                        onClick={this.navTogglerClickedSmall}
                                        aria-label={this.state.isSidebarVisible ? "Cerrar menÃº" : "Abrir menÃº"}
                                        aria-expanded={this.state.isSidebarVisible}
                                    >
                                        <i className={`fa ${this.state.isSidebarVisible ? "fa-times" : "fa-bars"}`} aria-hidden="true" />
                                    </button>
                                </div>
                                <div className="col-auto d-flex align-items-center navbar-mobile-search-toggle-slot">
                                    <button
                                        type="button"
                                        className="mobile-search-toggle"
                                        onClick={this.toggleMobileSearch}
                                        aria-label={this.state.isMobileSearchOpen ? "Cerrar bÃºsqueda" : "Abrir bÃºsqueda"}
                                        aria-expanded={this.state.isMobileSearchOpen}
                                    >
                                        <i className={`fa ${this.state.isMobileSearchOpen ? "fa-times" : "fa-search"}`} aria-hidden="true" />
                                    </button>
                                </div>
                                <div className="col-auto d-flex align-items-center">
                                    <DownloadApps />
                                </div>


                                <div className="col-auto navbar-nav my-lg-0">
                                    <Menu history={this.props.history} />
                                </div>

                            </div>
                        </div>

                    </div>
                </nav>

                {this.state.isMobileSearchOpen && (
                    <div className="navbar-mobile-search-drawer px-3 py-2">
                        <SearchBar idSeller={this.props.idSeller} listenClear={true} />
                    </div>
                )}

                {isImpersonating && (
                    <div
                        className="px-3 py-2 text-white"
                        style={{ backgroundColor: 'rgba(71, 8, 26, 0.92)', borderTop: '1px solid rgba(255,255,255,0.16)' }}
                    >
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 small">
                            <span>
                                Estas viendo la plataforma como <strong>{impersonation?.impersonatedNombre || this.props.userName}</strong> (ID {impersonation?.impersonatedUserId ?? this.props.userId}).
                            </span>
                            <span className="opacity-75">
                                Iniciada por {impersonation?.impersonatorNombre || 'administrador'}
                            </span>
                        </div>
                    </div>
                )}
            </header>
        );
    }
}

const mapStateToProps = (state) => ({
    idSeller: state.general?.idSeller,
    userId: state.general?.userId,
    userName: state.general?.userName,
    impersonation: state.general?.impersonation,
});

export default connect(mapStateToProps)(NavBar);
